import { render, staticRenderFns } from "./Legalitas.vue?vue&type=template&id=dc7e3824&scoped=true&"
import script from "./Legalitas.vue?vue&type=script&lang=js&"
export * from "./Legalitas.vue?vue&type=script&lang=js&"
import style0 from "./Legalitas.vue?vue&type=style&index=0&id=dc7e3824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7e3824",
  null
  
)

export default component.exports